module.exports = __webpack_public_path__ + "img/localadgsystems.303b49ad.jpeg";